'use strict';

var dialog = require('./dialog');
var util = require('./util');
var SessionAttributes = window.SessionAttributes;

/**
 * @function captcha    Used to display/control the scrim containing the simulated captcha code
 **/
module.exports = function () {
    /**
     * if the session.privacy.ratelimited element is present then show the notification
     * NOTE: You will probably want to replace this with a call to an actual CAPTCHA system to replace the simple one here
     */
    if (SessionAttributes.SHOW_CAPTCHA) {
        dialog.open({
            html: '<p class="heading heading--small">' + Resources.ARE_YOU_HUMAN + '</p><br /><button data-modal-close="true" class="button captcha-button button--full button--primary">'+ Resources.OK +'</button>',
            afterCreateCallback: function () {
                $('.captcha-button').on('click', function (e) {
                    var url = util.appendParamsToUrl(Urls.rateLimiterReset, {format: 'ajax'});

                    $.ajax({
                        url: url,
                        complete: function() {

                            if(util.getQueryString(window.location.href).indexOf('dwcont') >= 0) {
                                window.location.href = util.removeParamFromURL(window.location.href, 'dwcont');
                            }
                        }
                    });
                });
            },
            options: {
                modalID: 'modal--captcha',
                modalClass: 'modal--captcha align--center'
                // closeOnEscape: false,
                // dialogClass: 'no-close',
                // buttons: [{
                //     text: Resources.OK,
                //     click: function () {
                //         var url = util.appendParamsToUrl(Urls.rateLimiterReset, {format: 'ajax'});
                //         $.ajax({
                //             url: url
                //         });
                //         $(this).dialog('close');
                //     }
                // }]
            }
        });
    }
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/captcha.js